import React from 'react';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { ISearchQuery } from './ISearchQuery';
import {
  useGetACHIncomingExpectedQuery,
  useGetChecksIncomingExpectedQuery,
  useGetWiresIncomingExpectedQuery,
} from 'API/accounting/AccountingApi';
import { createDefaultSearchOrderSpecification } from 'ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { useSearchOrdersQuery } from 'API/order/OrderApi';

export interface ICancelPotentialMatchProps {
  query: ISearchQuery;
  cancel: () => void;
}

export const CancelPotentialMatch: React.FC<ICancelPotentialMatchProps> = ({ cancel, query }) => {
  const { data: wires } = useGetWiresIncomingExpectedQuery(query);
  const { data: checks } = useGetChecksIncomingExpectedQuery(query);
  const { data: achs } = useGetACHIncomingExpectedQuery(query);
  const { data: order } = useSearchOrdersQuery(
    {
      ...createDefaultSearchOrderSpecification(),
      fileNumbers: [query.fileNumber || ''],
    },
    { skip: !query.fileNumber }
  );

  const total =
    (wires?.totalElements || 0) +
    (checks?.totalElements || 0) +
    (achs?.totalElements || 0) +
    (order?.totalElements || 0);
  return (
    <CardTW
      title={
        <div className={'text-left'} onClick={cancel}>
          Match Against Something Else
          {!!total && (
            <span className="rounded-full font-medium text-xs px-2 py-1 bg-green-100 text-green-700 ml-8 align-middle">
              {total} Item{total === 1 ? '' : 's'}
            </span>
          )}
        </div>
      }
      contentClassName={'px-0'}
    />
  );
};
